// extracted by mini-css-extract-plugin
module.exports = {"container":"Group_container__3lIDl","row":"Group_row__1uMKr","title":"Group_title__2L0MX"};